import { Component, OnInit } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"
import { UserService } from "../../../services/user.service"
import { ReCaptchaV3Service } from "ng-recaptcha"
import { EduComponent } from "../../../utils/eduComponent"
import Utils from "../../../utils/utils"
import { ViewEnum } from "./student-signup-enum"
import { StudentLogin } from "../../../models/studentLogin"
import { Router } from "@angular/router"

@Component({
    selector: "app-student-signup-modal",
    templateUrl: "./student-signup-modal.component.html",
    styleUrls: ["./student-signup-modal.component.scss"],
})
export class StudentSignupModalComponent extends EduComponent implements OnInit {
    public selectedQuestion: number
    public secretQuestions = [
        { id: 1, name: "What is your favorite animal?" },
        { id: 2, name: "What is your favorite color?" },
        { id: 3, name: "What is your favorite food?" },
    ]

    public wordList1 = [
        "Analyzing",
        "Arriving",
        "Biking",
        "Breaking",
        "Catching",
        "Celebrating",
        "Chasing",
        "Climbing",
        "Coloring",
        "Composing",
        "Computing",
        "Cooking",
        "Crawling",
        "Dancing",
        "Deciphering",
        "Decoding",
        "Detecting",
        "Diving",
        "Drawing",
        "Eating",
        "Encoding",
        "Examining",
        "Falling",
        "Fighting",
        "Flexing",
        "Floating",
        "Flying",
        "Going",
        "Growling",
        "Hiking",
        "Hunting",
        "Infiltrating",
        "Investigating",
        "Jetsetting",
        "Jumping",
        "Landing",
        "Launching",
        "Leaving",
        "Outsmarting",
        "Painting",
        "Peeking",
        "Racing",
        "Reading",
        "Riding",
        "Rising",
        "Rolling",
        "Rowing",
        "Running",
        "Sailing",
        "Sewing",
        "Shopping",
        "Singing",
        "Skating",
        "Skiing",
        "Skydiving",
        "Sledding",
        "Sleeping",
        "Sliding",
        "Sneaking",
        "Solving",
        "Standing",
        "Studying",
        "Surfing",
        "Surviving",
        "Swimming",
        "Tasting",
        "Testing",
        "Twirling",
        "Unlocking",
        "Watching",
        "Winning",
        "Wrestling",
        "Writing",
        "Able",
        "Adept",
        "Adorable",
        "Amazing",
        "Artistic",
        "Astonishing",
        "Athletic",
        "Awesome",
        "Big",
        "Bold",
        "Bookish",
        "Brainy",
        "Brilliant",
        "Bubbly",
        "Cagey",
        "Careful",
        "Caring",
        "Clever",
        "Conniving",
        "Cool",
        "Crazy",
        "Creative",
        "Cute",
        "Dainty",
        "Delightful",
        "Devious",
        "Enormous",
        "Epic",
        "Evil",
        "Extreme",
        "Fabuloso",
        "Fantastic",
        "Festive",
        "Fiery",
        "Friendly",
        "Funny",
        "Gigantic",
        "Glamorous",
        "Good",
        "Goofy",
        "Hilarious",
        "Hungry",
        "Illustrious",
        "Indescribable",
        "Inky",
        "Iridescent",
        "Irrestistable",
        "Kind",
        "Lazy",
        "Lone",
        "Loud",
        "Magical",
        "Mighty",
        "Modest",
        "Nimble",
        "Phenomenal",
        "Powerful",
        "Quiet",
        "Random",
        "Safe",
        "Secret",
        "Shrewd",
        "Silly",
        "Sleepy",
        "Sly",
        "Smart",
        "Sneaky",
        "Sparkly",
        "Sporty",
        "Spunky",
        "Strong",
        "Super",
        "Sweet",
        "Talented",
        "Thoughtful",
        "Trendy",
        "Twinkling",
        "Unbelievable",
        "Unique",
        "Wise",
        "Witty",
        "Amber",
        "Amethyst",
        "Aqua",
        "Azure",
        "Beige",
        "Black",
        "Blue",
        "Brown",
        "Chartreuse",
        "Crimson",
        "Dark",
        "Emerald",
        "Fuschia",
        "Gray",
        "Green",
        "Indigo",
        "Ivory",
        "Jade",
        "Lavender",
        "Light",
        "Magenta",
        "Maroon",
        "Onyx",
        "Opal",
        "Orange",
        "Periwinkle",
        "Pink",
        "Platinum",
        "Purple",
        "Red",
        "Ruby",
        "Saphhire",
        "Scarlet",
        "Silver",
        "Teal",
        "Topaz",
        "Turquoise",
        "Violet",
        "White",
        "Yellow",
        "Aggressive",
        "Amused",
        "Angry",
        "Arrogant",
        "Bashful",
        "Beastly",
        "Befuddled",
        "Bemused",
        "Bored",
        "Calm",
        "Cautious",
        "Chatty",
        "Cheerful",
        "Cheery",
        "Confident",
        "Confused",
        "Delighted",
        "Determined",
        "Disappointed",
        "Disgusted",
        "Eager",
        "Easygoing",
        "Energetic",
        "Enthusiastic",
        "Excited",
        "Fearless",
        "Giddy",
        "Giggly",
        "Glad",
        "Gloomy",
        "Grateful",
        "Happy",
        "Hopeful",
        "Joyful",
        "Joyous",
        "Lively",
        "Lolsome",
        "Lonesome",
        "Lonely",
        "Mad",
        "Melancholy",
        "Mellow",
        "Merry",
        "Mischievous",
        "Monkeyish",
        "Nervous",
        "Optimistic",
        "Peaceful",
        "Pessimistic",
        "Proud",
        "Psyched",
        "Regretful",
        "Rueful",
        "Sad",
        "Shocked",
        "Shy",
        "Spirited",
        "Surprised",
        "Thankful",
        "Thrilled",
        "Tranquil",
        "Vexed",
        "Vivacious",
        "Zealous",
        "Afternoon",
        "Autumn",
        "Dawn",
        "Dreamtime",
        "Dusk",
        "Early",
        "Late",
        "Midnight",
        "Midsummer",
        "Midwinter",
        "Moonlight",
        "Moonrise",
        "Morning",
        "Night",
        "Spring",
        "Summer",
        "Sunrise",
        "Sunset",
        "Twilight",
        "Winter",
    ]
    public wordList2 = [
        "Acrobatics",
        "Adventure",
        "Art",
        "Astronomy",
        "Band",
        "Baseball",
        "Basketball",
        "Club",
        "Drama",
        "Fashion",
        "Celebration",
        "Chess",
        "Chorus",
        "Dance",
        "Football",
        "Game",
        "Guitar",
        "Gymnastics",
        "Hockey",
        "Journey",
        "Magic",
        "Math",
        "Music",
        "Mystery",
        "Party",
        "Poetry",
        "Pursuit",
        "Quest",
        "Science",
        "Soccer",
        "Softball",
        "Sports",
        "Study",
        "Surprise",
        "Technology",
        "Travel",
        "Trickery",
        "Trumpet",
        "Volleyball",
        "Yoga",
        "Bear",
        "Bee",
        "Beetle",
        "Bird",
        "Bloodhound",
        "Bull",
        "Bulldog",
        "Butterfly",
        "Cat",
        "Chicken",
        "Chihuahua",
        "Cobra",
        "Cow",
        "Cricket",
        "Crow",
        "Dinosaur",
        "Dog",
        "Dolphin",
        "Dragon",
        "Dragonfly",
        "Eagle",
        "Fly",
        "Gerbil",
        "Goat",
        "Gopher",
        "Gorilla",
        "Grasshopper",
        "Hamster",
        "Hawk",
        "Hippo",
        "Horse",
        "Hound",
        "Kangaroo",
        "Kitten",
        "KoalaBear",
        "Koi",
        "Labrador",
        "Ladybug",
        "Lamb",
        "Lion",
        "Lizard",
        "Llama",
        "Lynx",
        "Mink",
        "Monkey",
        "Moth",
        "Mouse",
        "Panda",
        "Panther",
        "Parakeet",
        "Penguin",
        "Pig",
        "Piglet",
        "PolarBear",
        "Pony",
        "Puffin",
        "Pug",
        "Puma",
        "Puppy",
        "Rabbit",
        "Raccoon",
        "Rattlesnake",
        "Raven",
        "Robin",
        "Rooster",
        "Salmon",
        "Seal",
        "Shark",
        "Sheep",
        "Snake",
        "Snapper",
        "Sparrow",
        "Spider",
        "Tiger",
        "Tuna",
        "Turkey",
        "Turtle",
        "Wallabee",
        "Warthog",
        "Whale",
        "Wolf",
        "Worm",
        "Antennae",
        "Arms",
        "Beak",
        "Brain",
        "Claws",
        "Elbow",
        "Eyes",
        "Fangs",
        "Feathers",
        "Fin",
        "Foot",
        "Fur",
        "Gills",
        "Hands",
        "Heart",
        "Jaw",
        "Knees",
        "Leg",
        "Mind",
        "Nose",
        "Paw",
        "Scales",
        "shell",
        "Skin",
        "Snout",
        "Talons",
        "Teeth",
        "Toes",
        "Flippers",
        "Tummy",
        "Whiskers",
        "Wings",
        "Apple",
        "Bagel",
        "Banana",
        "Brownie",
        "Cake",
        "Candy",
        "Caramel",
        "Cheese",
        "Cheeseburger",
        "Cherries",
        "Chicken",
        "Chocolate",
        "Coffee",
        "Cupcake",
        "Donut",
        "Eggs",
        "Grapes",
        "Ham",
        "Hamburger",
        "Honeydew",
        "Hotdog",
        "Hummus",
        "Icecream",
        "Ketchup",
        "Kiwi",
        "Lemon",
        "Lemonade",
        "Lime",
        "Melon",
        "Mustard",
        "Nectar",
        "Peach",
        "Pear",
        "Pie",
        "Pinapple",
        "Pistachio",
        "Pizza",
        "Plum",
        "Porkchop",
        "Potatochips",
        "Spaghetti",
        "Sprinkles",
        "Steak",
        "Strawberry",
        "Sushi",
        "Tea",
        "Vanilla",
        "Waffle",
        "Watermelon",
        "Angel",
        "Basilisk",
        "Boggart",
        "Centaur",
        "Cerberus",
        "Chimera",
        "Cyclops",
        "Dragon",
        "Elf",
        "Fairy",
        "Ghost",
        "Gnome",
        "Goblin",
        "Gorgon",
        "Griffin",
        "Hydra",
        "Imp",
        "Kraken",
        "Leprechaun",
        "Medusa",
        "Mermaid",
        "Merman",
        "Minotaur",
        "Monster",
        "Mummy",
        "Pegasus",
        "Wizard",
        "Phoenix",
        "Pixie",
        "Satyr",
        "Selkie",
        "Sphinx",
        "Sprite",
        "Sylph",
        "Troll",
        "Unicorn",
        "Vampire",
        "Werewolf",
        "Witch",
        "Zombie",
        "Anubis",
        "Aphrodite",
        "Apollo",
        "Ares",
        "Artemis",
        "Athena",
        "Bast",
        "Cupid",
        "Demeter",
        "Freya",
        "Hathor",
        "Hephaestus",
        "Hera",
        "Hermes",
        "Horus",
        "Ishtar",
        "Juno",
        "Loki",
        "Merlin",
        "Nephthys",
        "Odin",
        "Osiris",
        "Poseidon",
        "Sekhmet",
        "Serqet",
        "Set",
        "Sobek",
        "Thor",
        "Thoth",
        "Venus",
        "Vulcan",
        "Zeus",
        "Actor",
        "Admiral",
        "Agent",
        "Ambassador",
        "Astronaut",
        "Athlete",
        "Author",
        "Believer",
        "Bookworm",
        "Boy",
        "Brigadier",
        "Captain",
        "Challenger",
        "Chief",
        "Coach",
        "Collector",
        "Colonel",
        "Commander",
        "Corporal",
        "Dancer",
        "Detective",
        "Diplomat",
        "Director",
        "Dodger",
        "Dreamer",
        "Duchess",
        "Duke",
        "Expert",
        "Explorer",
        "Fashionista",
        "Forager",
        "General",
        "Genius",
        "Girl",
        "Guard",
        "Hero",
        "Heroine",
        "Hunter",
        "Inventor",
        "Investigator",
        "Junior",
        "King",
        "Lieutenant",
        "Musician",
        "Negotiator",
        "Ninja",
        "Nomad",
        "Officer",
        "Peacemaker",
        "President",
        "Prince",
        "Princess",
        "Queen",
        "Racer",
        "Raider",
        "Rascal",
        "Reader",
        "Rider",
        "Rogue",
        "Ruler",
        "Scientist",
        "Scrounger",
        "Searcher",
        "Seeker",
        "Senior",
        "Skater",
        "Sleeper",
        "Soldier",
        "Specialist",
        "Spy",
        "Stranger",
        "Surfer",
        "Surgeon",
        "Survivor",
        "Teacher",
        "Thief",
        "Trickster",
        "Warrior",
        "Winner",
        "Wrestler",
        "Writer",
        "Airport",
        "Arcade",
        "Bastion",
        "Capital",
        "Castle",
        "Chateau",
        "Citadel",
        "City",
        "Club",
        "Continent",
        "Country",
        "Creek",
        "Desert",
        "Field",
        "Forest",
        "Galaxy",
        "Hideout",
        "Hotel",
        "House",
        "Island",
        "Jungle",
        "Library",
        "Maze",
        "Meadow",
        "Metropolis",
        "Moon",
        "Museum",
        "Ocean",
        "Plains",
        "Sea",
        "Ship",
        "Shore",
        "Sky",
        "Skyscraper",
        "Station",
        "Street",
        "Stronghold",
        "Swamp",
        "Treehouse",
        "Underground",
        "Volcano",
        "Arrow",
        "Book",
        "Card",
        "Cash",
        "Clue",
        "Code",
        "Coin",
        "Compass",
        "Constellation",
        "Crest",
        "Crown",
        "Electricity",
        "Fan",
        "Fire",
        "Flash",
        "Game",
        "Hint",
        "History",
        "Ink",
        "Ipod",
        "Iron",
        "Key",
        "Kite",
        "Laptop",
        "Lock",
        "Map",
        "Medal",
        "Mystery",
        "Necklace",
        "Phone",
        "Prism",
        "Puppet",
        "Sand",
        "Song",
        "Saga",
        "Steel",
        "Stone",
        "Surprise",
        "Team",
        "Tide",
        "Tree",
        "Trick",
        "Wave",
        "Words",
        "Blizzard",
        "Breeze",
        "Cloud",
        "Cloudburst",
        "Cyclone",
        "Downpour",
        "Fog",
        "Freeze",
        "Frost",
        "Gale",
        "Gloom",
        "Gust",
        "Hail",
        "Haze",
        "Heatwave",
        "Hurricane",
        "Ice",
        "Lightning",
        "Maelstrom",
        "Mist",
        "Monsoon",
        "Nebula",
        "Pressure",
        "Rain",
        "Rainbow",
        "Snow",
        "Squall",
        "Steam",
        "Storm",
        "Sunshine",
        "Tempest",
        "Thunderstorm",
        "Tornado",
        "Tsunami",
        "Twister",
        "Vapor",
        "Wave",
    ]

    public ViewEnum = ViewEnum
    public questionAnswer: string = ""
    public customWord: string = ""
    public word1: string = ""
    public word2: string = ""
    public view: number = ViewEnum.chose
    public tmpUsername: string = this.customWord + this.word1 + this.word2
    public prevView = ViewEnum.chose
    public error = ""
    public studentLogin: StudentLogin
    public googleImage: string = null
    private token: string = ""

    constructor(
        public activeModal: ModalRef,
        public userService: UserService,
        private router: Router,
        private recaptchaV3Service: ReCaptchaV3Service
    ) {
        super()
        this.studentLogin = new StudentLogin(this.userService, this.router)
        this.googleImage = require("../../../../assets/auth-google.svg").default
    }

    ngOnInit() {
        Utils.shuffleArray(this.wordList1)
        Utils.shuffleArray(this.wordList2)
    }

    public getQuestionText(id) {
        const question = this.secretQuestions.filter((question) => {
            return id === question.id
        })

        return question[0].name
    }

    public setWord1(word) {
        this.word1 = word
        this.updateUserName()
    }

    public setWord2(word) {
        this.word2 = word
        this.updateUserName()
    }

    public updateUserName() {
        this.tmpUsername = this.customWord + this.word1 + this.word2
    }

    public nextPage() {
        if (this.isFormValid()) {
            this.view = ViewEnum.review
            this.error = ""
        }
    }

    public prevPage() {
        this.view = ViewEnum.create
    }

    public isFormValid() {
        return this.customWord && this.questionAnswer && this.selectedQuestion
    }

    public close() {
        this.prevView = this.view
        this.view = ViewEnum.close
    }

    public createStudent(): void {
        this.addSub(
            this.recaptchaV3Service.execute("studentCreate").subscribe(
                (token) => {
                    this.token = token
                    this.postData()
                },
                (error) => {
                    console.error(error)
                }
            )
        )
    }

    public postData() {
        this.addSub(
            this.userService
                .postCreateStudent({
                    custom_word: this.customWord,
                    first_word: this.word1,
                    second_word: this.word2,
                    secure_secret_question: this.getQuestionText(this.selectedQuestion),
                    secure_secret_answer: this.questionAnswer,
                    captcha: this.token,
                })
                .subscribe(
                    () => {
                        window.location.reload()
                    },
                    (err: any) => {
                        if (
                            err.error &&
                            err.error.non_field_errors &&
                            err.error.non_field_errors[0]
                        ) {
                            this.error = err.error.non_field_errors[0]
                            this.view = ViewEnum.create
                        }
                    }
                )
        )
    }
}
